import type { TFunction } from 'i18next'

import type { TagColor } from '@/components/Tag/Tag'

import type { SchoolYearStatus } from '../types'

export const schoolYearStatusToTagMap = (
  tc: TFunction<'schoolSettings'>
): Record<SchoolYearStatus, { label: string; color: TagColor }> => ({
  active: {
    color: 'green',
    label: tc('label.active')
  },
  future: {
    color: 'blue',
    label: tc('label.future')
  },
  archived: {
    color: 'gray',
    label: tc('label.past')
  }
})
